import { Fade } from 'react-reveal'

import SEO from 'src/components/SEO'
import PageHeader from 'src/components/about/PageHeader'
import PageDataStatus from 'src/components/about/PageDataStatus'
import PageExample from 'src/components/about/PageExample'
import PageReport from 'src/components/about/PageReport'

import { Divider } from '@mui/material'

const headerData = {
  title: '컴퓨터 비전 솔루션',
  desc: '디지털 이미지와 비디오를 처리하여 시각적 정보를 추출 및 해석'
}

const exampleData = [
  {
    example: '피부 상태 객체 인식',
    image: ['/images/about/vision_info1_frame.png']
  },
  {
    example: '터널 공사 굴착면 암반 상태 분류',
    image: ['/images/about/vision_info2_frame.png']
  }
]

const statusData = [
  {
    dataType: '피부 상태 분류를 위한 홍반, 색소 침착 등의 피부 상태 데이터',
    dataCount: '원천 데이터 900장 및 115,446장의 증강 데이터',
    dataDetail: [
      '• 한국데이터산업진흥원에서 지원하는 데이터 바우처 사업을 통하여 다양한 연령대별, 성별, 피부 상태별로 수집',
      '• 피부 상태 위치 및 종류에 대한 라벨링 파일 구축'
    ]
  },
  {
    dataType: '터널 공사 굴착면 암반 상태 분류(RMR) 및 절리(Joint) 인식을 위한 터널 굴착면 데이터',
    dataCount: '터널 굴착면 이미지 1,500장',
    dataDetail: [
      '• 암반 분류에 사용되는 거칠기, 풍화 정도 등의 Bieniawski의 평가 항목에 대한 라벨링된 파일 구축',
      '• 절리 인식 학습을 위한 절리 표시 파일 구축'
    ]
  }
]

const reportData = [
  {
    title: 'Yolov5를 이용한 피부 상태 객체 인식 학습 결과',
    content: [
      '• 5개의 라벨(홍반, 색소 침착, 여드름, 주름, 모공)에 대한 5,773개의 데이터를 활용하여 multi-class classification 성능 테스트',
      '• KOLAS 인증 기관인 슈어소프트테크를 통한 제3자 테스트 실시'
    ],
    image: ['/images/about/vision_test1.png', '/images/about/vision_test2.png']
  },
  {
    title: '터널 공사 굴착면 암반 상태 분류 및 절리 인식 시스템 학습 결과',
    content: [
      '• Keras application의 사전 학습 모델을 이용한 거칠기, 충전물, 풍화 정도, 지하수 4가지 특성에 대한 학습',
      '• KOLAS 인증 기관인 슈어소프트테크를 통한 제3자 테스트 실시'
    ],
    image: ['/images/about/vision_test4.png']
  }
]

export default function Vision({ headUrl, headTitle, headDesc }) {
  return (
    <section className='page-content py-24 tracking-tight lg:py-40'>
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <Fade clear>
        {/* 타이틀 및 설명 */}
        <PageHeader title={headerData.title} desc={headerData.desc} />

        <div className='title-box flex flex-col gap-10 p-6 bg-white lg:gap-20 lg:p-12'>
          {/* 사용 예시 */}
          <PageExample data={exampleData} />
          <Divider />

          {/* 데이터 보유 현황 */}
          <PageDataStatus data={statusData} />
          <Divider />

          {/* 시험 성적서 */}
          <PageReport data={reportData} />
        </div>
      </Fade>
    </section>
  )
}

export async function getStaticProps() {
  let headTitle = 'AISO VISION'
  let headDesc = '컴퓨터 비전 솔루션'
  const headUrl = `https://aisodata.co.kr/about/vision`

  return { props: { headUrl, headTitle, headDesc } }
}
